import React, { PureComponent } from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import CustomerButton from "../customer-button/CustomerButton";
//Limitless imports

class MarketingCard extends PureComponent {
  render() {
    const {
      classes,
      img,
      title,
      buttonTitle,
      desc,
      backgroundColor,
      contrastColour,
      id
    } = this.props;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Card, {
      className: classes.card
    }, /*#__PURE__*/React.createElement(CardMedia, {
      className: classes.media,
      image: img,
      style: {
        backgroundColor,
        padding: 5
      }
    }), /*#__PURE__*/React.createElement(CardContent, {
      className: classes.cardContent
    }, /*#__PURE__*/React.createElement(Typography, {
      style: {
        color: contrastColour
      },
      variant: "h6"
    }, title), /*#__PURE__*/React.createElement(Typography, {
      style: {
        color: contrastColour
      },
      component: "p"
    }, /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: desc
      }
    }))), /*#__PURE__*/React.createElement(CardActions, {
      className: classes.cardActions
    }, /*#__PURE__*/React.createElement(CustomerButton, {
      onClick: this.props.buttonClickHandle,
      id: `mediaCardButton${id}`
    }, buttonTitle))));
  }
}
const styles = {
  card: {
    width: 240,
    marginBottom: 40
  },
  media: {
    height: 150,
    backgroundSize: "contain"
  },
  cardActions: {
    justifyContent: "center"
  }
};
export default withStyles(styles)(MarketingCard);
MarketingCard.propTypes = {
  classes: PropTypes.object.isRequired,
  img: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  desc: PropTypes.string,
  buttonTitle: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string.isRequired,
  contrastColour: PropTypes.string.isRequired,
  buttonClickHandle: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired
};